import {IAction, IPayloadAction} from 'core/store'
import {delay} from 'redux-saga'
import {all, call, put, takeLatest} from 'redux-saga/effects'

export const SNACKBAR_SET_REQUEST = 'main/SNACKBAR_SET_REQUEST'
export const SNACKBAR_SET = 'main/SNACKBAR_SET'
export const SNACKBAR_RESET = 'main/SNACKBAR_RESET'

export interface IActionSnackbarSetRequest extends
  IPayloadAction<typeof SNACKBAR_SET_REQUEST, string> {}
const snackbarSetRequest = (payload: string): IActionSnackbarSetRequest => ({
  type: SNACKBAR_SET_REQUEST,
  payload,
})

interface IActionSnackbarSet extends
  IPayloadAction<typeof SNACKBAR_SET, string> {}
const snackbarSet = (payload: string): IActionSnackbarSet => ({
  type: SNACKBAR_SET,
  payload,
})

interface IActionSnackbarReset extends
  IAction<typeof SNACKBAR_RESET> {}
const snackbarReset = (): IActionSnackbarReset => ({
  type: SNACKBAR_RESET,
})

export const actions = {
  snackbarSetRequest,
  snackbarSet,
  snackbarReset,
}

export type TAction =
  IActionSnackbarSet |
  IActionSnackbarReset

export interface State {
  isActive: boolean
  label: string
}

const initialState: State = {
  isActive: false,
  label: '',
}

export const reducer = (state: State = initialState, action: TAction): State => {
  switch (action.type) {
    case SNACKBAR_SET:
      return {
        ...state,
        isActive: true,
        label: action.payload,
      }
    case SNACKBAR_RESET:
      return {
        ...state,
        isActive: false,
      }
    default:
      return state
  }
}

export function* snackbarSetRequestSaga(action: IActionSnackbarSetRequest) {
  yield put(snackbarSet(action.payload))
  // TODO someday, we might want to be able to configure timeouts,
  // but for now a hard standard is sufficient
  yield call(delay, 5000)
  yield put(snackbarReset())
}

export function* saga() {
  yield all([
    takeLatest(SNACKBAR_SET_REQUEST, snackbarSetRequestSaga),
  ])
}



// WEBPACK FOOTER //
// ./~/tslint-loader??ref--0!./study_reviewer/src/store/main/snackbar.ts